import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

const profiles = [
  {
    tag: "Studenten",
    desc: "Flexibel neben dem Studium. Kein Kapital nötig.",
    note: "5–10h/Woche reichen",
  },
  {
    tag: "Quereinsteiger",
    desc: "Kein Tech-Hintergrund? Die KI macht den Rest.",
    note: "Erster Kunde in unter 24h möglich",
  },
  {
    tag: "Freelancer",
    desc: "3x schneller als klassische Tools — deutlich mehr Umsatz.",
    note: "Höhere Margen, weniger Zeit",
  },
  {
    tag: "Nebenjob-Suchende",
    desc: "Schon ein Projekt im Monat bringt 1.000–3.000€ extra — pro Website.",
    note: "Kein fixes Stundensoll",
  },
];

export default function ForWhomSection() {
  return (
    <section
      className="py-32 md:py-40 px-6 bg-[#0A0A0A]"
      data-testid="for-whom-section"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease }}
          className="text-center mb-20"
        >
          <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">
            Für wen?
          </span>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-black text-[#F5F5F7] mt-4 tracking-tight"
            style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "-0.02em" }}
          >
            Für jeden, der starten will.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 sm:divide-x divide-white/6 border border-white/6 rounded-2xl overflow-hidden">
          {profiles.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, ease, delay: i * 0.07 }}
              className={`p-8 sm:p-10 bg-[#0A0A0A] hover:bg-[#111111] transition-colors duration-300 ${i >= 2 ? "border-t border-white/6" : ""}`}
              data-testid={`profile-card-${i}`}
            >
              <span className="text-[#C9A84C] text-xs font-bold tracking-widest uppercase">
                {p.tag}
              </span>
              <p className="text-[#F5F5F7] text-lg font-semibold mt-3 mb-2 leading-snug">{p.desc}</p>
              <p className="text-[#86868b] text-sm">{p.note}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
